var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"fill":"none","stroke":"#0098D7","strokeWidth":"1.45","points":"18 25 23 20 18 15","transform":"translate(-17 -14)"}));
}

ChevronRightInline.defaultProps = {"width":"7","height":"12","viewBox":"0 0 7 12"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
